import { c as _c } from "react/compiler-runtime";
import { AboveValueConfigKind, BelowValueConfigKind, BetweenValueConfigKind, UserConversationsCountValueConfig } from '@/api/generated/model';
import { useState } from 'react';
import { translate } from '@/utils/translations';
import { nullableNumberToString } from '@/utils/numbers.util';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/comps/primitives/select';
import { Button } from '@/comps/primitives/button';
import { Input } from '@/comps/primitives/input';
type ValueKind = BetweenValueConfigKind | AboveValueConfigKind | BelowValueConfigKind;
type IProps = {
  onApply: (e: UserConversationsCountValueConfig) => void;
};
export const UserConversationsCountForm = t0 => {
  const $ = _c(40);
  const {
    onApply
  } = t0;
  const [valueKind, setValueKind] = useState("above");
  const [firstNumber, setFirstNumber] = useState(10);
  const [secondNumber, setSecondNumber] = useState(10);
  let t1;
  if ($[0] !== firstNumber || $[1] !== onApply || $[2] !== secondNumber || $[3] !== valueKind) {
    t1 = () => {
      if (valueKind === AboveValueConfigKind.above || valueKind === BelowValueConfigKind.below) {
        onApply({
          conversations_count: {
            kind: valueKind,
            value: firstNumber,
            offset: new Date().getTimezoneOffset()
          }
        });
      } else {
        if (valueKind === BetweenValueConfigKind.between) {
          onApply({
            conversations_count: {
              kind: "between",
              value: [firstNumber, secondNumber],
              offset: new Date().getTimezoneOffset()
            }
          });
        }
      }
    };
    $[0] = firstNumber;
    $[1] = onApply;
    $[2] = secondNumber;
    $[3] = valueKind;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const apply = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="text-sm">Users who have</p>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => setValueKind(value as ValueKind);
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== valueKind) {
    t4 = translate("value_config_kind", valueKind);
    $[7] = valueKind;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <SelectTrigger className="w-auto"><SelectValue>{t4}</SelectValue></SelectTrigger>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectItem value={AboveValueConfigKind.above}>{translate("value_config_kind", AboveValueConfigKind.above)}</SelectItem>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SelectItem value={BelowValueConfigKind.below}>{translate("value_config_kind", BelowValueConfigKind.below)}</SelectItem>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SelectContent>{t6}{t7}<SelectItem value={BetweenValueConfigKind.between}>{translate("value_config_kind", BetweenValueConfigKind.between)}</SelectItem></SelectContent>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== valueKind) {
    t9 = <Select value={valueKind} onValueChange={t3}>{t5}{t8}</Select>;
    $[14] = t5;
    $[15] = valueKind;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== firstNumber) {
    t10 = nullableNumberToString(firstNumber);
    $[17] = firstNumber;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setFirstNumber(parseInt(e.target.value));
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <Input value={t10} type="number" className="h-8 w-12 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" onChange={t11} />;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== secondNumber || $[23] !== valueKind) {
    t13 = valueKind === BetweenValueConfigKind.between && <><p className="text-sm">and</p><Input value={nullableNumberToString(secondNumber)} type="number" className="h-8 w-12 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" onChange={e_0 => setSecondNumber(parseInt(e_0.target.value))} /></>;
    $[22] = secondNumber;
    $[23] = valueKind;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== valueKind) {
    t14 = valueKind !== BetweenValueConfigKind.between && <p className="text-sm">conversations</p>;
    $[25] = valueKind;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t9) {
    t15 = <div className="flex items-center gap-2">{t9}{t12}{t13}{t14}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== valueKind) {
    t16 = valueKind === BetweenValueConfigKind.between && <p className="text-sm">conversations</p>;
    $[32] = valueKind;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== apply) {
    t17 = <Button className="mt-1" size="sm" onClick={apply}>Apply</Button>;
    $[34] = apply;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t16 || $[38] !== t17) {
    t18 = <div className="flex flex-col gap-2">{t2}{t15}{t16}{t17}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};